import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons'
import type { Channel } from '@entities/channel'
import { useChannels } from '@entities/channel'
import { InternetRecourceType } from '@entities/channel/model/types'
import type { Partner } from '@entities/partner'
import { CopyButton } from '@shared/ui/copy-button/copy-button'
import type { FormProps, TableProps } from 'antd'
import { Button, Col, Dropdown, Form, Input, Popconfirm, Row, Space, Table, theme, Typography } from 'antd'
import { useMemo } from 'react'

const { Text } = Typography

interface AdvertisingPlatformsProps {
    partner: Partner
    isLinkedPartner: boolean
}

export type FieldType = {
    id: number
    type: InternetRecourceType
    name: string
    partnerId: number
}

export const AdvertisingPlatforms = ({ partner, isLinkedPartner }: AdvertisingPlatformsProps) => {
    const {
        partnerResources,
        actions: { createChannel, editChannel, deleteChannel, refetchPartnerResources }
    } = useChannels(partner.id)

    const onFinish: FormProps<FieldType>['onFinish'] = async (values) => {
        if (values.id) {
            await editChannel({ id: values.id, data: { name: values.name, type: values.type } })
            refetchPartnerResources()
        } else {
            await createChannel(values)
            refetchPartnerResources()
        }
        form.resetFields()
    }

    const [form] = Form.useForm<FieldType>()

    const {
        token: { colorLink }
    } = theme.useToken()

    const columns: TableProps<Channel>['columns'] = useMemo(
        () => [
            {
                title: 'Название интернет ресурса',
                dataIndex: 'name',
                key: 'name',
                render: (_, record) => (
                    <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                        <Text>{record.name}</Text>
                        <CopyButton textToCopy={record.name} />
                    </Space>
                )
            },
            {
                title: '',
                key: 'action',
                hidden: isLinkedPartner,
                render: (_, record) => (
                    <Dropdown
                        trigger={['click']}
                        menu={{
                            items: [
                                {
                                    key: '1',
                                    label: (
                                        <Space style={{ color: colorLink, width: '100%' }}>
                                            <EditOutlined /> Редактировать
                                        </Space>
                                    ),
                                    onClick: () => form.setFieldsValue({ ...record, partnerId: partner.id })
                                },
                                {
                                    key: '3',
                                    danger: true,
                                    label: (
                                        <Popconfirm
                                            title="Удалить площадку"
                                            description="Вы уверены что хотите удалить площадку?"
                                            onConfirm={async () => {
                                                await deleteChannel({ id: record.id })
                                                refetchPartnerResources()
                                            }}
                                            okText="Удалить"
                                            cancelText="Отмена"
                                        >
                                            <Space style={{ width: '100%' }}>
                                                <DeleteOutlined /> Удалить
                                            </Space>
                                        </Popconfirm>
                                    )
                                }
                            ]
                        }}
                    >
                        <MoreOutlined />
                    </Dropdown>
                )
            }
        ],
        [colorLink, deleteChannel, form, isLinkedPartner, partner.id, refetchPartnerResources]
    )

    // const advertisingPlatformsToDisplay = useMemo(() => {
    //     if (isLinkedPartner) {
    //         return advertisingPlatforms?.filter((i) => i.visible)
    //     } else {
    //         return advertisingPlatforms
    //     }
    // }, [advertisingPlatforms, isLinkedPartner])

    return (
        <>
            <Form
                form={form}
                name="add-adv-platform"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={onFinish}
                initialValues={{
                    type: InternetRecourceType.site
                }}
            >
                <Row gutter={16} align={'bottom'}>
                    <Form.Item hidden name="partnerId" initialValue={partner.id} />
                    <Form.Item hidden name="isFake" initialValue={true} />
                    <Form.Item hidden name="id" />
                    <Form.Item hidden name="type" />
                    <Col span={4}>
                        <Form.Item
                            label="Введите название канала  или интернет ресурса"
                            name="name"
                            required={false}
                            rules={[{ required: true, message: 'Обязательное поле' }]}
                        >
                            <Input placeholder="@username / https://telegaplan.me" />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ marginBottom: 24 }}
                            disabled={isLinkedPartner}
                        >
                            Сохранить
                        </Button>
                    </Col>
                </Row>
            </Form>
            <Row>
                <Col span={7}>
                    <Table<Channel> columns={columns} dataSource={partnerResources} rowKey={'id'} pagination={false} />
                </Col>
            </Row>
        </>
    )
}
